import { ITabFilter } from "./Tabs";
import { Box, Typography } from "@maysoft/common-component-react";

export const TabItem = ({ item, isActive, onClick }: { item: ITabFilter; isActive: boolean; onClick: () => void }) => {
    const Icon = item.Icon;
    return (
        <Box display="flex">
            <Box
                display="flex"
                alignItems="center"
                gap={1}
                py={1.5}
                px={2}
                sx={({ palette: { info } }) => ({
                    ...(isActive && {
                        borderBottom: `2px solid ${info.main}`,
                        "& svg": {
                            fill: info.main,
                        },
                        "& span": {
                            color: info.main,
                        },
                    }),
                    ...(!isActive && {
                        "& svg": {
                            fill: "#637381",
                        },
                        "& span": {
                            color: "#637381",
                        },
                    }),
                    "&:hover": {
                        cursor: "pointer",
                    },
                })}
                onClick={(e) => {
                    e.stopPropagation();
                    onClick();
                }}
            >
                {Icon && Icon}
                <Typography
                    variant="caption"
                    sx={{
                        fontWeight: 600,
                        width: "max-content"
                    }}
                >
                    {item.title}
                </Typography>
                {item.customSuffix && item.customSuffix}
            </Box>
        </Box>
    );
};

export default TabItem;
